import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

type ResendInvitation = {
  id: string
  type: 'flat' | 'offer'
  /** Only for the success toast. */
  email?: string
}

/** The same signing invitation e-mail again — same link, sent by us. */
export function useResendSignInvitation() {
  const toast = useToast()
  const { t } = useTranslation('contract')
  const onError = useOnError()

  return useMutation({
    mutationFn: async ({ id, type }: ResendInvitation) => {
      await apiClient.post(
        `${SNA_PREFIX}contracts/${id}/resend-invitation`,
        undefined,
        { params: { type } }
      )
    },
    onSuccess: (_, { email }) => {
      toast.success({
        message: t('contract_table.resend_invitation_sent', { email })
      })
    },
    onError
  })
}
